import { render, staticRenderFns } from "./BrandStatistics.vue?vue&type=template&id=0d60f092&scoped=true"
import script from "./BrandStatistics.vue?vue&type=script&lang=js"
export * from "./BrandStatistics.vue?vue&type=script&lang=js"
import style0 from "./BrandStatistics.vue?vue&type=style&index=0&id=0d60f092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60f092",
  null
  
)

export default component.exports